<template>
  <div class="navbar">
    <hamburger id="hamburger-container" :is-active="sidebar.opened" class="hamburger-container" @toggleClick="toggleSideBar" />

    <breadcrumb id="breadcrumb-container" class="breadcrumb-container" />

    <div class="right-menu">
      <template v-if="device!=='mobile'">
        <!--搜索-->
        <!--<search id="header-search" class="right-menu-item" />-->

        <!--错误日志-->
        <!--<error-log class="errLog-container right-menu-item hover-effect" />-->

        <!--全屏-->
        <!--<screenfull id="screenfull" class="right-menu-item hover-effect" />-->

        <!--布局大小-->
        <!--<el-tooltip :content="$t('navbar.size')" effect="dark" placement="bottom">-->
        <!--<size-select id="size-select" class="right-menu-item hover-effect" />-->
        <!--</el-tooltip>-->

        <!--语言-->
        <!--<lang-select class="right-menu-item hover-effect" />-->

      </template>

      <!--登陆/推出-->
      <!--<el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">-->
      <!--<div class="avatar-wrapper">-->
      <!--<img :src="avatar+'?imageView2/1/w/80/h/80'" class="user-avatar">-->
      <!--<i class="el-icon-caret-bottom" />-->
      <!--</div>-->
      <!--<el-dropdown-menu slot="dropdown">-->
      <!--<router-link to="/profile/index">-->
      <!--<el-dropdown-item>-->
      <!--{{ $t('navbar.profile') }}-->
      <!--</el-dropdown-item>-->
      <!--</router-link>-->
      <!--<router-link to="/">-->
      <!--<el-dropdown-item>-->
      <!--{{ $t('navbar.dashboard') }}-->
      <!--</el-dropdown-item>-->
      <!--</router-link>-->
      <!--<a target="_blank" href="https://github.com/PanJiaChen/vue-element-admin/">-->
      <!--<el-dropdown-item>-->
      <!--{{ $t('navbar.github') }}-->
      <!--</el-dropdown-item>-->
      <!--</a>-->
      <!--<a target="_blank" href="https://panjiachen.github.io/vue-element-admin-site/#/">-->
      <!--<el-dropdown-item>Docs</el-dropdown-item>-->
      <!--</a>-->
      <!--<el-dropdown-item divided>-->
      <!--<span style="display:block;" @click="logout">{{ $t('navbar.logOut') }}</span>-->
      <!--</el-dropdown-item>-->
      <!--</el-dropdown-menu>-->
      <!--</el-dropdown>-->
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import { removeToken, removeRoles } from '@/utils/auth'
// import ErrorLog from '@/components/ErrorLog'
// import Screenfull from '@/components/Screenfull'
// import SizeSelect from '@/components/SizeSelect'
// import LangSelect from '@/components/LangSelect'
// import Search from '@/components/HeaderSearch'

export default {
  components: {
    Breadcrumb,
    Hamburger
    // ErrorLog,
    // Screenfull,
    // SizeSelect,
    // LangSelect,
    // Search
  },
  computed: {
    ...mapGetters(['sidebar', 'avatar', 'device'])
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    async logout() {
      await this.$store.dispatch('user/logout').then(_ => {
        removeToken()
        removeRoles()
      })
      this.$router.push(`/login?redirect=${this.$route.fullPath}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar {
	margin-top: 70px;
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
